import React from 'react'
import type { JSONContent } from '../types'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { parseStyleString } from '../utils'
import { convertStylesToSx } from '../utils'

interface RenderButtonProps {
  node: JSONContent
}

export function RenderButton({ node }: RenderButtonProps) {
  const attrs = node.attrs || {}
  const {
    text = 'Button',
    url = '#',
    alignment = 'left',
    variant = 'filled',
    buttonColor = '#3b82f6',
    textColor = '#ffffff',
    borderRadius = 'smooth',
    paddingTop = 10,
    paddingRight = 32,
    paddingBottom = 10,
    paddingLeft = 32,
  } = attrs
  const buttonStyle = convertStylesToSx(parseStyleString(attrs.style as string))

  let radius = '0px'
  if (borderRadius === 'round') {
    radius = '9999px'
  } else if (borderRadius === 'smooth') {
    radius = '6px'
  }

  const backgroundColor = variant === 'filled' ? buttonColor : 'transparent'
  const borderColor = buttonColor

  return (
    <Box
      sx={{
        marginBottom: 2,
        textAlign: alignment as 'left' | 'center' | 'right',
      }}
    >
      <Button
        variant={variant === 'filled' ? 'contained' : 'outlined'}
        onClick={() => {
          if (url && url !== '#') {
            window.open(url, '_blank')
          }
        }}
        sx={{
          color: textColor,
          backgroundColor,
          borderColor,
          borderWidth: '2px',
          borderStyle: 'solid',
          borderRadius: radius,
          paddingTop: `${paddingTop + 2}px`,
          paddingRight: `${paddingRight}px`,
          paddingBottom: `${paddingBottom + 2}px`,
          paddingLeft: `${paddingLeft}px`,
          ...buttonStyle,
        }}
      >
        {text}
      </Button>
    </Box>
  )
}
